<template>
    <AuthenticatedLayout>
        <Toast position="top-center" />

        <div v-if="$page.props.auth.user.is_demo">
            <DemoBotWarning :current-date="currentDate"/>
        </div>

        <div class="text-4xl mr-4 my-4 ">High-Low Level bots
            <span v-if="profitToday >= 0" class="text-green-500 pl-4">${{profitToday}}</span>
            <span v-if="profitToday < 0" class="text-red-500 pl-4">${{profitToday}}</span>
            <span class="text-base text-gray-800">за сегодня</span>
        </div>
        <Card class="mb-4">
            <template #content>
                <PairsTwoTableSelector :items="botPairMenuItems" :compact="false" :select="handleSelectPair">
                </PairsTwoTableSelector>
            </template>
        </Card>

        <Card class="mb-4">
            <template #title>
                Прибыль по месяцам за период (последних месяцев: {{numMonths}})
            </template>
            <template #content>
                <DataTable :value="pairsMonthlyStats" dataKey="pairId" selectionMode="single" class="p-datatable-sm">
                    <Column class="w-9rem">
                        <template #body="{data}">
                            <div class="flex flex-row align-items-center">
                                <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
                                    <img :src="data.pair_icon_url" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="data.pair.symbol"/>
                                </div>
                                <div class="text-xl ml-4">
                                    {{data.pair.symbol}}
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column :header="'За период'" >
                        <template #body="{data}">
                            <div class="mb-2" v-html="round_colored(data.profit_hll, 2)"></div>
                            <div class="ml-1 text-gray-500">инвест: {{round(data.market_profit, 2)}}</div>
                        </template>
                    </Column>
                    <Column v-for="month of months" :header="month" :key="month">
                        <template #body="{data}">
                            <div class="flex flex-row align-items-center">
                                <div class="mr-2" v-html="round_colored(data.calc[month].profit_hll, 2)"></div>
                                <div class="text-gray-500">({{data.calc[month].percent_hll}}%)</div>
                            </div>
                            <div class="flex flex-row align-items-center text-gray-500 text-sm">
                                <div class="ml-1 mr-2">рынок: {{round(data.calc[month].market_change_percent, 2)}}%</div>
                            </div>
                        </template>
                    </Column>
                    <ColumnGroup type="footer">
                        <Row>
                            <Column footer="Итого:" :footerStyle="{'text-align':'right'}"/>
                            <Column :footer="calcTotalPeriod" />
                            <Column v-for="month of months" :key="month" :footer="calcTotalMonth(month)" />
                        </Row>
                    </ColumnGroup>

                </DataTable>
            </template>
        </Card>


    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import helperMethods from '@/helpers';
import Card from "primevue/card";
import InputSwitch from "primevue/inputswitch";
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";
import DemoBotWarning from "@/Components/DemoBotWarning.vue";
import InlineMessage from "primevue/inlinemessage";

export default {
    components:{
        PairsTwoTableSelector,
        AuthenticatedLayout, Toast, DataTable, Column, ColumnGroup, Row, Card, InputSwitch, DemoBotWarning, InlineMessage
    },
    props:{
        botPairMenuItems: Array,
        profitToday: Number,
        currentDate: String,
        pairsMonthlyStats: Array,
        months: Array,
        maxOpenDeals: Number,
        buyAmountUsd: Number,
        numMonths: Number,
    },
    data(){
        return {
            selectedPair: null,
        }
    },
    methods:{
        ...helperMethods,
        handleSelectPair(botPairMenuData){
            this.$inertia.visit(`/hll/${botPairMenuData.pair_name}`)
        },
        displayPercent(percent){
            let p = this.round(percent - 100, 2);
            let str = "";
            if(p > 0){
                str = "+"+p+"%";
            }else{
                str = p+"%";
            }
            return str;
        },
        calculateVolume($profit, $percent){
            return this.round($profit / $percent * 100);
        },
        calcTotalMonth(month){
            let total = 0;
            for(let pair of this.pairsMonthlyStats){
                if(!pair.calc[month]){
                    continue;
                }
                total += pair.calc[month].profit_hll;
            }
            return this.round(total, 2);
        },
    },
    computed:{
        user(){
            return this.$page.props.auth.user;
        },
        calcTotalPeriod(){
            let total = 0;
            for(let pair of this.pairsMonthlyStats){
                total += pair.profit_hll;
            }
            return this.round(total, 2);
        },
    }


}
</script>
